
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['container', 'chevron', 'paragraph', 'fullContent']
  static classes = [ 'bg', 'chevron' ]

  toggle() {
    this.paragraphTargets.forEach(element => {
      element.classList.toggle('hidden')
    });

    this.containerTarget.classList.toggle(this.bgClass)
    this.containerTarget.classList.toggle('bg-white')

    this.chevronTarget.classList.toggle(this.chevronClass)
    this.fullContentTarget.classList.toggle('hidden')
  }
}
